module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "id": "mainwrap"
    }
  }, [_c('tweetCon', {
    attrs: {
      "articleInfo": _vm.articleInfo
    }
  }), _vm._v(" "), (_vm.loadItem) ? _c('comments', {
    attrs: {
      "articleId": _vm.article_id,
      "time": 3000
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bodyLoad && _vm.loadItem && !_vm.isInApp) ? _vm._m(0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadFooter', {
    attrs: {
      "text": _vm.$t('downloadForComments')
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1375e68","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppTweet.vue
// module id = 903
// module chunks = 7